/* src/app/dashboard/charts/users-usage/users-usage.component.css */
.canvas-container {
  justify-content: stretch;
  display: flex;
  flex: 1 1 auto;
  align-items: stretch;
}
.canvas-block {
  display: block;
  width: 100%;
}
/*# sourceMappingURL=users-usage.component.css.map */
